import newIcon from '@/public/images/icons/notifications/new.svg';
import askIcon from '@/public/images/icons/notifications/ask.svg';
import bidIcon from '@/public/images/icons/notifications/bid.svg';
import expireIcon from '@/public/images/icons/notifications/expire.svg';
import matchIcon from '@/public/images/icons/notifications/match.svg';
import error from '@/public/images/icons/notifications/error.svg';
import { ImagesPressLogosGoldBlueSpiritoryLogoSvg } from '@/assets/images_press_logos_gold-blue.assets';
import { NotificationType } from '@/types/other';

export function getIconByNotificationType(type: NotificationType) {
  const typeLower = type.toLowerCase() as NotificationType;
  const image = {
    new: {
      icon: newIcon,
    },
    ask: {
      icon: askIcon,
    },
    bid: {
      icon: bidIcon,
    },
    expired: {
      icon: expireIcon,
    },
    match: {
      icon: matchIcon,
    },
    information: {
      icon: newIcon,
    },
    wishlist: {
      icon: newIcon,
    },
    error: {
      icon: error,
    },
    onboarding: {
      icon: ImagesPressLogosGoldBlueSpiritoryLogoSvg,
    },
    shipping_policy: {
      icon: ImagesPressLogosGoldBlueSpiritoryLogoSvg,
    },
  };

  return image[`${typeLower}`].icon;
}

export function getUrlNotification(url: string | undefined | null) {
  return url
    ? url.includes('/buying') || url.includes('/selling')
      ? url.replace('#', '?type=')
      : url
    : url;
}

export function getTextNotification(notificationType: NotificationType) {
  return notificationType[0] + notificationType.slice(1, notificationType.length).toLowerCase();
}
